import { useMemo } from 'react';
import type { IApiErrorPlain } from '@platform/core/types';
import { useListAllRecordsQuery } from '@platform/state/api';
import type { ILibraryCollectionsData } from './ILibraryCollectionsData';
import { collectionOf } from './collectionModel';

/** Бібліотеки бази знань простору (усі записи типу добірок за номером); без типу добірок — порожньо. */
export function useLibraryCollections(ws: string, collectionRt: string | undefined): ILibraryCollectionsData {
  const { data, isLoading, error } = useListAllRecordsQuery({ ws, rt: collectionRt ?? '', params: { sort: 'code' } }, { skip: !collectionRt });
  const collections = useMemo(() => [...(data?.items ?? [])].sort((a, b) => a.code - b.code).map(collectionOf), [data]);
  return { collections, isLoading, error: error as IApiErrorPlain | undefined };
}
